import { render, staticRenderFns } from "./Guide.vue?vue&type=template&id=a0c176d4&scoped=true&"
import script from "./Guide.vue?vue&type=script&lang=ts&"
export * from "./Guide.vue?vue&type=script&lang=ts&"
import style0 from "./Guide.vue?vue&type=style&index=0&id=a0c176d4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0c176d4",
  null
  
)

export default component.exports